'use client';

import type { PropsWithChildren } from 'react';

import posthog from 'posthog-js';
import { PostHogProvider as PostHogJSProvider } from 'posthog-js/react';

// Bridges the posthog singleton (init'd in instrumentation-client.ts) into React context.
export function PostHogProvider({ enabled, children }: PropsWithChildren<{ enabled: boolean }>) {
  if (!enabled) return <>{children}</>;
  return <PostHogJSProvider client={posthog}>{children}</PostHogJSProvider>;
}
